<template>
    <div class="CompanyLayout">
        <CompanySidebar ref="companySidebar"/>

        <div class="main" v-if="id">
            <div class="header">
                <div>
                    <div class="menu" @click="toggleMenu">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <div class="headerAside">
                    <a href="/support" target="_blank" class="support">
                        <Icon name="question-circle"/>
                        <span>Help</span>
                    </a>

                    <Dropdown v-if="user">
                        <template #trigger>
                            <CompanyLogo nameDisplay="user"/>
                        </template>
                        <template #menu>
                            <router-link to="/company/settings">Settings</router-link>
                            <button class="danger" @click="handleLogout">Log out</button>
                        </template>
                    </Dropdown>
                </div>
            </div>

            <div v-if="user.role === 'admin'" class="banner">
                <div>Currently logged in as: {{ adminCompany.name }}</div>
                <router-link to="/admin/companies">
                    <Icon name="times"/>
                    <span>Exit access</span>
                </router-link>
            </div>

            <SubscriptionStatusAlert/>

            <div class="content">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import CompanySidebar from './components/CompanySidebar';
import SubscriptionStatusAlert from './components/SubscriptionStatusAlert';
import CompanyLogo from '@/components/CompanyLogo';
import Dropdown from '@/components/Dropdown';

export default {
    name: 'CompanyLayout',

    components: { CompanySidebar, SubscriptionStatusAlert, CompanyLogo, Dropdown },

    computed: {
        ...mapState('auth', ['user', 'adminCompany']),
        ...mapState('company', ['id', 'subscription']),
    },

    beforeMount() {
        this.$store.dispatch('company/fetchOverview');
    },

    methods: {
        toggleMenu() {
            this.$refs.companySidebar.toggle();
        },

        handleLogout() {
            this.$store.dispatch('auth/logout', { redirect: true });
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.CompanyLayout {
    @extend %dashboard-layout;

    .banner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px $grid-gutter-width;
        background-color: $blue-color;
        font-weight: $font-weight-bold;
        color: #fff;

        a {
            display: flex;
            align-items: center;
            color: #fff;
            cursor: pointer;

            .Icon {
                margin-right: 10px;
            }
        }
    }

    .headerAside {
        display: flex;
        align-items: center;

        .support {
            display: flex;
            align-items: center;
            margin-right: 40px;
            color: $text-color-muted;

            &:hover {
                color: $button-primary-color;
            }

            @include breakpoint(sm) {
                margin-right: 20px;
            }
        }

        .Icon {
            margin-right: 10px;
            font-size: 22px;
        }
    }
}
</style>
